import React from 'react';

import { ShowingDetailsProps } from '../types';
import { ShowingDetailsContextProvider } from './ShowingDetailsContext';
import ShowingDetailsLayout from './ShowingDetailsLayout';

const ShowingDetails: React.FC<ShowingDetailsProps> = props => (
    <ShowingDetailsContextProvider {...props}>
      <ShowingDetailsLayout />
    </ShowingDetailsContextProvider>
  );

export default ShowingDetails;
